export default "__VITE_ASSET__1585b138__$_?nuxt_component=async__"